import React from "react";
import AdminModal from "./AdminModal";
import { AlertTriangle } from "lucide-react";

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  confirmVariant = "danger",
}) {
  return (
    <AdminModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      maxWidth="440px"
      footer={
        <>
          <button
            className="admin-btn admin-btn-secondary"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className={`admin-btn admin-btn-${confirmVariant}`}
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmText}
          </button>
        </>
      }
    >
      <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
        <div
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            background: confirmVariant === "danger" ? "#fee2e2" : "#e0f2fe",
            color: confirmVariant === "danger" ? "#dc2626" : "#0284c7",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <AlertTriangle size={20} />
        </div>
        <div style={{ fontSize: "14px", color: "#475569", lineHeight: "1.5" }}>
          {message}
        </div>
      </div>
    </AdminModal>
  );
}
